import { MAX_NUMBER_OF_PAGES, MIN_BOX_BOOK_NUMBER_OF_PAGES } from 'common/utils/bookSize.constants'
import { MOSAIC_SIZES, PRICING } from 'artkive/utils/constants'

import ReturnArtImage from 'images/ecom/pricing/addons/ArtReturn.svg'
import ExtraCopies from 'images/ecom/pricing/addons/ExtraCopies.svg'
import USBImage from 'images/ecom/pricing/addons/USB.svg'
import VIPMembership from 'images/ecom/pricing/addons/VIPMembership.svg'

export const returnArtAddon = {
  title: 'Art Return — ${price}',
  description: 'Have your original pieces shipped back to you.',
  image: ReturnArtImage,
}

export const returnUsbAddon = {
  title: 'USB — ${price}',
  description: 'USB drive with all of your high resolution images.',
  image: USBImage,
}

export const productBullets = [
  { text: '24”x 17”x 4” crush-proof Artkive Box (holds 300-400 pieces of art)' },
  { text: 'Prepaid return shipping label to send your box back' },
  { text: 'Final payment based on number of pieces sent' },
]

export const costAddons = [
  {
    title: 'Want Extra Copies?',
    description: 'Get copies of your book for 60% OFF!',
    image: ExtraCopies,
  },
  {
    title: 'VIP Membership',
    description: 'Get 2 boxes a year, free rush, and other exclusive perks.',
    image: VIPMembership,
  },
]

export const boxProductDisclaimers = [
  '*Artkive Box sold separately — see link below',
  `*If your Artkive Box isn’t returned within ${PRICING.books.dueBackMonths} months, we’ll process your deposit and apply it as a credit toward your final order total.`,
]

// The Pricing page keeps its own product bullets so copy changes on the product pages do not leak here.
export const pricingBookBullets = [
  { text: 'Professional photography, editing of each piece of art, and a digital proof to review' },
  {
    text:
      `Books range from ${MIN_BOX_BOOK_NUMBER_OF_PAGES}-${MAX_NUMBER_OF_PAGES} images and come ` +
      'in two sizes: 8"x8" or 11"x8.5"',
  },
  { text: 'Premium matte printing and ability to add custom cover and captions' },
  { text: 'Access to your digital images on our website and the iOS app' },
]

export const pricingMosaicBullets = [
  { text: `Showcases ${MOSAIC_SIZES.CLASSIC} or ${MOSAIC_SIZES.SMALL} of your images depending on size` },
  { text: '26"x26" or 14"x14" solid wood, gallery frame and professional matting' },
  { text: 'Professional photography, editing of each piece of art, and a digital proof to review' },
  { text: 'Access to your digital images on our website and the iOS app' },
]
